import axiosInstance from "./axiosInstance";

export const submitFinalAssessment = async (courseId, answers) => {
  const response = await axiosInstance.post(
    `/final-assessment/courses/${courseId}/final-assessment/submit`,
    { answers }
  );

  return response.data;
};